import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { confirmPopup } from "primereact/confirmpopup";
import { deleteService, getServices } from "../../redux/actions/serviceAction";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getServices(setLoading));
    }, [dispatch]);

    let { allServices } = useSelector((state) => state.service);

    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter((item) => item?.serviceName.toLowerCase()?.includes(search.toLowerCase()));
        }
        return data;
    };

    allServices = getFilteredData(allServices, search);

    const onDelete = (e, data) => {
        confirmPopup({
            target: e.currentTarget,
            message:
                "Are you sure you want to delete this service? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteService(data)),
            reject: () => {},
        });
    };

    return {
        allServices,
        loading,
        history,
        search,
        setSearch,
        onDelete,
    };
}
